import axios from ".";

export const getTermsOfServices = () => {
  return axios({
    method: "GET",
    url: `/terms-of-services`,
  });
};

export const createTermsOfServices = (data: any) => {
  return axios({
    method: "POST",
    url: `/terms-of-services`,
    data,
  });
};

export const editTermsOfServices = (termsOfServicesId: any, data: any) => {
  return axios({
    method: "PUT",
    url: `/terms-of-services/${termsOfServicesId}`,
    data: data,
  });
};
